export default __webpack_public_path__ + "static/media/point-status-3.f695266b.svg";